import VForm from "@/vuetify_custom/v-form";
import VModel from "@/vuetify_custom/v-modal_v1";
import { TEXT_FIELD } from "@/vuetify_custom/v-form/type_name";
import { sellOrderCompleteOrderApi } from "./services";

const createParams = () => {
  return {
    id: null,
    memo: null,
  };
};

export default {
  data() {
    return {
      dis: false,
      submitLoading: false,
      params: createParams(),
    };
  },
  computed: {
    baseInfoFields() {
      const d = [(val) => !!val || "必选"];
      const arr = [
        {
          label: "备注",
          type: TEXT_FIELD,
          key: "memo",
          cols: 12,
        },
      ];
      return arr.filter((item) => !item.hide);
    },
  },
  mounted() {},
  watch: {},
  methods: {
    open(id) {
      this.params.id = id;
      this.dis = true;
      this.params.memo = null;
    },
    submit() {
      this.submitLoading = true;

      sellOrderCompleteOrderApi(this.params)
        .then(() => {
          this.dis = false;
          this.$emit("success");
          this.$Message.success("保存成功！");
        })
        .finally(() => {
          this.submitLoading = false;
        });
    },
    close() {
      this.dis = false;
      this.$emit("close");
    },
  },
  render() {
    return (
      <VModel
        v-model={this.dis}
        persistent
        dynamic-height
        height-rate={0.7}
        title={"确认完成"}
        loading={this.submitLoading}
        on={{
          ok: this.submit,
          cancel: this.close,
        }}
      >
        <div>确定要完成该订单吗？</div>
        <VForm ref="base" v-model={this.params} fields={this.baseInfoFields} />
      </VModel>
    );
  },
};
